import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RangeSlider } from '@/components/RangeSlider';
import { CalculatorNumberInput } from '@/components/inputs';
import { formatAmount } from '@/utils/formatting';
import { Language } from '@/constants/currencyConfig';
const FIELD_CURRENT_PAYMENT = 'currentPayment';
const FIELD_MONTH_SPENDINGS = 'monthSpendings';
const FORM_NAME = 'calculatorForm';
const STEP = 1000;
type Props = {
  monthSpendingsMax: number;
  monthSpendingsMin: number;
  onChange: ({
    currentPayment,
    monthSpendings
  }: {
    currentPayment: number;
    monthSpendings: number;
  }) => void;
};
export function CalculatorForm(props) {
  const $ = _c(112);
  const {
    monthSpendingsMax,
    monthSpendingsMin,
    onChange
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["postponeDueDate"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation(t0);
  const t1 = Math.ceil(monthSpendingsMax / 2 / 20);
  const t2 = monthSpendingsMax / 2;
  let t3;
  if ($[1] !== t1 || $[2] !== t2) {
    t3 = {
      [FIELD_CURRENT_PAYMENT]: t1,
      [FIELD_MONTH_SPENDINGS]: t2
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [values, setValues] = useState(t3);
  let t4;
  if ($[4] !== onChange || $[5] !== values) {
    t4 = (fieldName, min, max) => input => {
      const value = typeof input === "number" ? input : typeof input === "string" ? parseFloat(input) : parseFloat(input.target.value);
      const newValues = {
        ...values,
        [fieldName]: !value ? min : Math.min(Math.max(Math.ceil(value), min), max)
      };
      setValues(newValues);
      onChange(newValues);
    };
    $[4] = onChange;
    $[5] = values;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleChange = t4;
  const handleChangeOnEnter = _temp;
  const currentPaymentMax = values[FIELD_MONTH_SPENDINGS];
  const currentPaymentMin = Math.ceil(values[FIELD_MONTH_SPENDINGS] / 20);
  let T0;
  let handleCurrentPaymentChange;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== currentPaymentMax || $[8] !== currentPaymentMin || $[9] !== handleChange || $[10] !== i18n.language || $[11] !== monthSpendingsMax || $[12] !== monthSpendingsMin || $[13] !== t || $[14] !== values) {
    handleCurrentPaymentChange = handleChange(FIELD_CURRENT_PAYMENT, currentPaymentMin, currentPaymentMax);
    let T1;
    let handleMonthSpendingsChange;
    let t15;
    let t16;
    let t17;
    let t18;
    if ($[27] !== handleChange || $[28] !== monthSpendingsMax || $[29] !== monthSpendingsMin || $[30] !== t || $[31] !== values) {
      handleMonthSpendingsChange = handleChange(FIELD_MONTH_SPENDINGS, monthSpendingsMin, monthSpendingsMax);
      t14 = FORM_NAME;
      t12 = "flex flex-col gap-10";
      t17 = "mb-3 flex flex-row items-center justify-between";
      let t19;
      if ($[40] !== t) {
        t19 = t("calculator.q1");
        $[40] = t;
        $[41] = t19;
      } else {
        t19 = $[41];
      }
      if ($[42] !== t19) {
        t18 = <p className="text-base font-semibold md:text-2xl">{t19}</p>;
        $[42] = t19;
        $[43] = t18;
      } else {
        t18 = $[43];
      }
      T1 = CalculatorNumberInput;
      t15 = values[FIELD_MONTH_SPENDINGS];
      t16 = handleChangeOnEnter(handleMonthSpendingsChange);
      $[27] = handleChange;
      $[28] = monthSpendingsMax;
      $[29] = monthSpendingsMin;
      $[30] = t;
      $[31] = values;
      $[32] = T1;
      $[33] = handleMonthSpendingsChange;
      $[34] = t12;
      $[35] = t14;
      $[36] = t15;
      $[37] = t16;
      $[38] = t17;
      $[39] = t18;
    } else {
      T1 = $[32];
      handleMonthSpendingsChange = $[33];
      t12 = $[34];
      t14 = $[35];
      t15 = $[36];
      t16 = $[37];
      t17 = $[38];
      t18 = $[39];
    }
    let t19;
    if ($[44] !== T1 || $[45] !== handleMonthSpendingsChange || $[46] !== monthSpendingsMax || $[47] !== monthSpendingsMin || $[48] !== t15 || $[49] !== t16) {
      t19 = <T1 value={t15} onKeyPress={t16} max={monthSpendingsMax} min={monthSpendingsMin} name={FIELD_MONTH_SPENDINGS} onBlur={handleMonthSpendingsChange} withCurrency={true} />;
      $[44] = T1;
      $[45] = handleMonthSpendingsChange;
      $[46] = monthSpendingsMax;
      $[47] = monthSpendingsMin;
      $[48] = t15;
      $[49] = t16;
      $[50] = t19;
    } else {
      t19 = $[50];
    }
    let t20;
    if ($[51] !== t17 || $[52] !== t18 || $[53] !== t19) {
      t20 = <div className={t17}>{t18}{t19}</div>;
      $[51] = t17;
      $[52] = t18;
      $[53] = t19;
      $[54] = t20;
    } else {
      t20 = $[54];
    }
    const t21 = i18n.language as Language;
    let t22;
    if ($[55] !== monthSpendingsMax || $[56] !== t21) {
      t22 = formatAmount(monthSpendingsMax, t21);
      $[55] = monthSpendingsMax;
      $[56] = t21;
      $[57] = t22;
    } else {
      t22 = $[57];
    }
    const t23 = i18n.language as Language;
    let t24;
    if ($[58] !== monthSpendingsMin || $[59] !== t23) {
      t24 = formatAmount(monthSpendingsMin, t23);
      $[58] = monthSpendingsMin;
      $[59] = t23;
      $[60] = t24;
    } else {
      t24 = $[60];
    }
    const t25 = values[FIELD_MONTH_SPENDINGS];
    const t26 = values[FIELD_MONTH_SPENDINGS];
    let t27;
    if ($[61] !== handleMonthSpendingsChange || $[62] !== monthSpendingsMax || $[63] !== monthSpendingsMin || $[64] !== t22 || $[65] !== t24 || $[66] !== t25 || $[67] !== t26) {
      t27 = <RangeSlider max={monthSpendingsMax} maxLabel={t22} minLabel={t24} min={monthSpendingsMin} name={FIELD_MONTH_SPENDINGS} onBlur={handleMonthSpendingsChange} onChange={handleMonthSpendingsChange} step={STEP} value={t25} aria-valuemin={monthSpendingsMin} aria-valuemax={monthSpendingsMax} aria-valuenow={t26} />;
      $[61] = handleMonthSpendingsChange;
      $[62] = monthSpendingsMax;
      $[63] = monthSpendingsMin;
      $[64] = t22;
      $[65] = t24;
      $[66] = t25;
      $[67] = t26;
      $[68] = t27;
    } else {
      t27 = $[68];
    }
    if ($[69] !== t20 || $[70] !== t27) {
      t13 = <div>{t20}{t27}</div>;
      $[69] = t20;
      $[70] = t27;
      $[71] = t13;
    } else {
      t13 = $[71];
    }
    t10 = "mb-3 flex flex-row items-center justify-between";
    let t28;
    if ($[72] !== t) {
      t28 = t("calculator.q2");
      $[72] = t;
      $[73] = t28;
    } else {
      t28 = $[73];
    }
    if ($[74] !== t28) {
      t11 = <p className="text-base font-semibold md:text-2xl">{t28}</p>;
      $[74] = t28;
      $[75] = t11;
    } else {
      t11 = $[75];
    }
    T0 = CalculatorNumberInput;
    t5 = currentPaymentMax;
    t6 = currentPaymentMin;
    t7 = FIELD_CURRENT_PAYMENT;
    t8 = handleCurrentPaymentChange;
    t9 = handleChangeOnEnter(handleCurrentPaymentChange);
    $[7] = currentPaymentMax;
    $[8] = currentPaymentMin;
    $[9] = handleChange;
    $[10] = i18n.language;
    $[11] = monthSpendingsMax;
    $[12] = monthSpendingsMin;
    $[13] = t;
    $[14] = values;
    $[15] = T0;
    $[16] = handleCurrentPaymentChange;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[15];
    handleCurrentPaymentChange = $[16];
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
    t14 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  const t15 = Math.min(Math.max(values[FIELD_CURRENT_PAYMENT], currentPaymentMin), currentPaymentMax);
  let t16;
  if ($[76] !== T0 || $[77] !== t15 || $[78] !== t5 || $[79] !== t6 || $[80] !== t7 || $[81] !== t8 || $[82] !== t9) {
    t16 = <T0 max={t5} min={t6} name={t7} onBlur={t8} onKeyPress={t9} value={t15} withCurrency={true} />;
    $[76] = T0;
    $[77] = t15;
    $[78] = t5;
    $[79] = t6;
    $[80] = t7;
    $[81] = t8;
    $[82] = t9;
    $[83] = t16;
  } else {
    t16 = $[83];
  }
  let t17;
  if ($[84] !== t10 || $[85] !== t11 || $[86] !== t16) {
    t17 = <div className={t10}>{t11}{t16}</div>;
    $[84] = t10;
    $[85] = t11;
    $[86] = t16;
    $[87] = t17;
  } else {
    t17 = $[87];
  }
  const t18 = i18n.language as Language;
  let t19;
  if ($[88] !== currentPaymentMax || $[89] !== t18) {
    t19 = formatAmount(currentPaymentMax, t18);
    $[88] = currentPaymentMax;
    $[89] = t18;
    $[90] = t19;
  } else {
    t19 = $[90];
  }
  const t20 = i18n.language as Language;
  let t21;
  if ($[91] !== currentPaymentMin || $[92] !== t20) {
    t21 = formatAmount(currentPaymentMin, t20);
    $[91] = currentPaymentMin;
    $[92] = t20;
    $[93] = t21;
  } else {
    t21 = $[93];
  }
  const t22 = Math.min(Math.max(values[FIELD_CURRENT_PAYMENT], currentPaymentMin), currentPaymentMax);
  const t23 = values[FIELD_CURRENT_PAYMENT];
  let t24;
  if ($[94] !== currentPaymentMax || $[95] !== currentPaymentMin || $[96] !== handleCurrentPaymentChange || $[97] !== t19 || $[98] !== t21 || $[99] !== t22 || $[100] !== t23) {
    t24 = <RangeSlider max={currentPaymentMax} maxLabel={t19} minLabel={t21} min={currentPaymentMin} name={FIELD_CURRENT_PAYMENT} onBlur={handleCurrentPaymentChange} onChange={handleCurrentPaymentChange} step={STEP} value={t22} aria-valuemin={currentPaymentMin} aria-valuemax={currentPaymentMax} aria-valuenow={t23} />;
    $[94] = currentPaymentMax;
    $[95] = currentPaymentMin;
    $[96] = handleCurrentPaymentChange;
    $[97] = t19;
    $[98] = t21;
    $[99] = t22;
    $[100] = t23;
    $[101] = t24;
  } else {
    t24 = $[101];
  }
  let t25;
  if ($[102] !== t17 || $[103] !== t24) {
    t25 = <div>{t17}{t24}</div>;
    $[102] = t17;
    $[103] = t24;
    $[104] = t25;
  } else {
    t25 = $[104];
  }
  let t26;
  if ($[105] !== t12 || $[106] !== t13 || $[107] !== t25) {
    t26 = <div className={t12}>{t13}{t25}</div>;
    $[105] = t12;
    $[106] = t13;
    $[107] = t25;
    $[108] = t26;
  } else {
    t26 = $[108];
  }
  let t27;
  if ($[109] !== t14 || $[110] !== t26) {
    t27 = <form name={t14}>{t26}</form>;
    $[109] = t14;
    $[110] = t26;
    $[111] = t27;
  } else {
    t27 = $[111];
  }
  return t27;
}
function _temp(changeHandler) {
  return e => {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      changeHandler(e.currentTarget.value.toString());
    }
  };
}